import classNames from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { ProjectId } from 'api/models';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { RTE } from 'components/atoms/rte';
import { ActionBar } from 'components/molecules/action-bar';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import styles from './approval.module.css';

interface MessageEditorProps extends ClassNamePropsWithChildren {
  data: string;
  onChange?: (data: string) => void;
  readonly?: boolean;
  placeholder?: string;
  editorClassName?: string;
  projectId: ProjectId;
}
export const MessageEditor: FC<MessageEditorProps> = (props) => {
  const {
    data,
    onChange,
    readonly = false,
    placeholder,
    className,
    editorClassName,
    projectId,
  } = props;
  const [rte, setRte] = useState<RichTextEditor | null>(null);

  useEffect(() => {
    rte?.focus();
  }, [rte]);

  const handleChange = (latest: string) => {
    if (onChange) {
      onChange(latest);
    }
  };

  return (
    <div className={classNames(styles.editor_wrapper, className)}>
      <RTE
        disallowImages
        placeholder={placeholder}
        projectId={projectId}
        readonly={readonly}
        ref={setRte}
        className={classNames(
          styles.editor,
          {
            [styles.editor_hide]: !data && readonly,
          },
          editorClassName,
        )}
        data={data}
        onChange={handleChange}
      />
      {!readonly && (
        <ActionBar>
          <ActionBar.Secondary>
            <RichTextEditor.EmojiPicker
              enabled
              onSelect={(emoji) => rte?.addEmoji(emoji)}
            />
          </ActionBar.Secondary>
        </ActionBar>
      )}
    </div>
  );
};
